import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { CustomPaginationComponent } from '../pages/common-modals/custom-pagination/custom-pagination.component';
import { ManualComplianceLabelPipe } from '../pipes/manual-compliance-label.pipe';
import { AccountingChargeSummary } from './accounting-charge-summary/accounting-charge-summary';

const CORE_MODULES = [CommonModule, FormsModule, ReactiveFormsModule];
const MAT_MODULES = [MatTabsModule, TooltipModule, MatDatepickerModule];
const THIRD_PARTY_MODULES = [InlineSVGModule];

@NgModule({
  imports: [...CORE_MODULES, ...MAT_MODULES, PaginationModule, ...THIRD_PARTY_MODULES],
  declarations: [CustomPaginationComponent, ManualComplianceLabelPipe, AccountingChargeSummary],
  exports: [
    ...CORE_MODULES,
    ...MAT_MODULES,
    PaginationModule,
    ...THIRD_PARTY_MODULES,
    CustomPaginationComponent,
    ManualComplianceLabelPipe,
    AccountingChargeSummary,
  ],
})
export class SharedModule {}
